const RELAY_FUTURE_UNION_VALUE = "%other";
export default RELAY_FUTURE_UNION_VALUE;
